import { useEffect, useRef, useState } from 'react';
import TempEdgeApi from '../../services/TempEdgeApi';
import { extractRows, toOptions } from '../../utils/lookupOptions';

const DEFAULT_PAYLOAD = { page: 0, size: 200, filterBy: {} };

const useLookupOptions = (shouldFetch, { url, payload = DEFAULT_PAYLOAD, backendType, idKeys, labelKeys, onError }) => {
  const [options, setOptions] = useState([]);
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  useEffect(() => {
    if (!shouldFetch || options.length > 0) return;

    const fetchOptions = async () => {
      try {
        const request = { url, payload };
        if (backendType) request.backendType = backendType;

        const { data } = await TempEdgeApi.post(request);
        setOptions(toOptions(extractRows(data), idKeys, labelKeys));
      } catch (error) {
        onErrorRef.current?.(error);
      }
    };

    fetchOptions();
  }, [shouldFetch, options.length, url, backendType, idKeys, labelKeys]);

  return options;
};

export default useLookupOptions;
